module.exports = __webpack_public_path__ + "static/media/S_F01.38af2fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_F01.png
// module id = 80
// module chunks = 0